<template>
  <div class="reef-bottom">
    <div class="rellax reef-bottom__inner reef-bottom__inner--1" data-rellax-speed="-7" data-rellax-percentage="0.3">
      <div class="reef-bottom__bg"></div>
    </div>
    <div class="rellax reef-bottom__inner reef-bottom__inner--2" data-rellax-speed="-4" data-rellax-percentage="0.3">
      <div class="reef-bottom__bg"></div>
    </div>
    <div class="rellax reef-bottom__inner reef-bottom__inner--3" data-rellax-speed="-2" data-rellax-percentage="0.3">
      <div class="reef-bottom__bg"></div>
    </div>
    <div class="rellax reef-bottom__inner reef-bottom__inner--4" data-rellax-speed="-1" data-rellax-percentage="0.3">
      <div class="reef-bottom__bg"></div>
    </div>
  </div>
</template>
<script>
  export default {
  }
</script>